import Agro1Toast from '../../components/Agro1Toast';

const TOAST_ERROR_LIFE_MS = 8000;

const aproveToast = {
  error(detail?: string) {
    Agro1Toast.show({
      detail: detail ?? 'Falha ao aprovar registro.',
      severity: 'error',
      life: TOAST_ERROR_LIFE_MS,
    });
  },

  rejectSuccess() {
    Agro1Toast.show({
      detail: 'Aplicação pendente excluída com sucesso.',
      severity: 'success',
    });
  },

  rejectError() {
    Agro1Toast.show({
      detail: 'Falha ao excluir a aplicação pendente.',
      severity: 'error',
      life: TOAST_ERROR_LIFE_MS,
    });
  },

  noRecords() {
    Agro1Toast.show({
      detail: 'Não há registros para o período informado.',
      severity: 'warn',
      life: TOAST_ERROR_LIFE_MS,
    });
  },

  reportError() {
    Agro1Toast.show({
      detail: 'Falha ao gerar relatório.',
      severity: 'error',
      life: TOAST_ERROR_LIFE_MS,
    });
  },
};

export default aproveToast;
